import React, { useEffect, useState } from 'react'
import { Layout, message, Col, Row, Tabs } from 'antd'
import { sendHttpPostRequest } from '../../api/http-request'
import courseMainStyles from './course-main.module.less'
import './course.module.css'
import * as constants from '../../constants/constants'
import LoginRegisterModal from '../../component/modal/login-register/login-register'
import { checkUserLogin } from '../common/user-center/user-info'
import PlatformCourseCases from './case/platform-course-cases'
import PlatformCourseSlides from './slides/platform-course-slides'

import {CalendarOutlined, ExperimentOutlined, FileTextOutlined, MenuOutlined} from '@ant-design/icons';
const { TabPane } = Tabs
import UserInfo from '../common/user-center/user-info';
import Feedback from '../common/feedback-help/feedback'
import Cookies from 'js-cookie'
import PlatformMenuPreview from './menu/platform-course-menu-preview'
import LockedMenuPreview from './menu/locked-course-menu-preview'
import PlatformCourseExercises from './platform-course-exercises'


import Icon from '@ant-design/icons'

import  {ReactComponent as mymenuSvg }   from '../../static/image/course/mymenu.svg'
import { ReactComponent as myslidesSvg }   from '../../static/image/course/myslides.svg'
import { ReactComponent as myexerciseSvg }   from '../../static/image/course/myexercise.svg'
const myexerciseIcon = (props:any) => (<Icon component={myexerciseSvg} {...props} />)

const mymenuIcon = (props:any) => (<Icon component={mymenuSvg} {...props} />)
const myslidesIcon = (props:any) => (<Icon component={myslidesSvg} {...props} />)








import { ReactComponent as eyeSvg }   from '../../static/image/module/eye.svg'


const eyeIcon = (props:any) => (<Icon component={eyeSvg} {...props} />)

export interface Props {}

/**平台课程主页面*/
export const CourseMain: React.FC<Props> = (props) => {
  const courseId = parseInt(window.location.search.split('=')[1]) // 课程ID
  const [course, setCourse] = useState(null as any) //课程信息
  const [courseName, setCourseName] = useState('') //课程名称
  const [courseDescription, setCourseDescription] = useState('') //课程介绍
  const [courseCover, setCourseCover] = useState(null as any) //课程封面路径

  const [isLogin, setIsLogin] = useState(false) //是否登录
  const [collegeId, setCollegeId] = useState(null as any) // 院校ID
  const [collegeInfo, setCollegeInfo] = useState(null as any) //查询当前用户的机构信息,is_college_teacher weitrue表示是教师，

  const [menuId, setMenuId] = useState(null as any) //课程大纲
  const [isBuyModalVisible, setIsBuyModalVisible] = useState(true)

  const [isSystemCourse, setIsSystemCourse] = useState(null as any) //是否为平台课
  const [isPay, setIsPay] = useState(null as any) //当前机构是否已经购买该课程
  const [isOverDue, setIsOverDue] = useState(false) //当前机构的这个课程是否已经到期

  const [isCollegeTeacher, setIsCollegeTeacher] = useState(null as any) //当前机构是否是机构的教师


  useEffect(() => {
    sendHttpPostRequest(
      'account/api/query_teacher_authenticate',
      {
        sessionid: Cookies.get('sessionid'),
        sid: Cookies.get('sessionid'),
      },
      (response: any) => {
        if (response.is_ok == true) {
          setIsLogin(true)
          if (response?.college_info?.college_id !== '') {
            //已加入机构
            let _collegeId = response.college_info.college_id
            setCollegeId(_collegeId)
            setCollegeInfo(response.college_info)
            queryCourseInCollege(_collegeId)
            setIsCollegeTeacher(response.college_info.is_college_teacher)
          } else {
            //未加入机构
            setCollegeId(0)
            queryCourse()
            setIsPay(false)
          }
        } else {
          //用户未登录
          setIsLogin(false)
          queryCourse()
        }
      }
    )
  }, [])

  // 查询课程信息
  const queryCourse = () => {
    const sessionid = Cookies.get('sessionid')
    const queryData = {
      source: 1,
      course_id: courseId,
      sessionid: sessionid,
      sid: sessionid,
    }
    sendHttpPostRequest(
      'course/api/user_query_course_by_id',
      queryData,
      courseCallback
    )
  }

  // 查询课程信息,已加入机构
  const queryCourseInCollege = (college_id) => {
    const sessionid = Cookies.get('sessionid')
    const queryData = {
      source: 1,
      course_id: courseId,
      college_id: college_id,
      sessionid: sessionid,
      sid: sessionid,
    }
    sendHttpPostRequest(
      'course/api/user_query_course_by_id',
      queryData,
      courseInCollegeCallback
    )
  }

  // 查询课程接口回调
  const courseCallback = (response: any) => {
    console.log(response)
    message.destroy()
    //if (response.code == -100) {
    // 未登录
    //document.getElementById("show-login-modal")!.click();
    //} else
    if (response.is_ok == true) {
      // 成功
      setCourse(response.query_info)
      setCourseName(response.query_info.name)
      setCourseDescription(response.query_info.description)
      setCourseCover(response.query_info.cover)
      setMenuId(response.query_info.syllabus_id)
      setIsSystemCourse(response.query_info.is_platform_course)
    } else if (response.code == -501) {
      // 权限不足
      message.error('权限不足')
    } else {
      message.error(response.message)
    }
  }

  // 查询课程接口回调,机构用户
  const courseInCollegeCallback = (response: any) => {
    console.log(response)
    message.destroy()
    //if (response.code == -100) {
    // 未登录
    //document.getElementById("show-login-modal")!.click();
    //} else
    if (response.is_ok == true) {
      // 成功
      setCourse(response.query_info)
      setCourseName(response.query_info.name)
      setCourseCover(response.query_info.cover)
      setCourseDescription(response.query_info.description)
      setMenuId(response.query_info.syllabus_id)
      setIsSystemCourse(response.query_info.is_platform_course)
      setIsPay(response.query_info.ispay)
      console.log(response.query_info.ispay)

      const date_end = new Date(response.query_info.apply_end_time);
      const date_now = new Date();
      const timeDiff = date_end.getTime() - date_now.getTime();
      if(timeDiff <= 0){
        setIsOverDue(true) //已过期
      }else{
        setIsOverDue(false)//没过期
      }

    } else if (response.code == -501) {
      // 权限不足
      message.error('权限不足')
    } else {
      message.error(response.message)
    }
  }

  const onCourseLearnClick = () => {
    if (!checkUserLogin()) {
      sessionStorage.setItem("previousurl",window.location.href )
      document.getElementById('show-login-modal')!.click()
    } else {
      if (course.recent_knowledge_url != '') {
        window.open(course.recent_knowledge_url)
      } else if (course.first_knowledge_url != '') {
        window.open(course.first_knowledge_url)
      } else {
        message.destroy()
        message.error('课程暂时无法学习，请稍候...')
      }
    }
  }
  

    /**
   * 创建课程回调
   * @param response
   */
    const setCreateCourseCallback = (response: any) => {
      message.destroy()
      if (response.code == -100) {
        // 没登录
        sessionStorage.setItem("previousurl",window.location.href )
        document.getElementById('show-login-modal')!.click()
      } else if (response.code == -501) {
        // 没权限
        window.location.href = '/login?next=course'
      } else if (response.is_ok == true) {
        if (response.course_id) {
          window.open(`/course-main-teacher?course_id=${response.course_id}&tabKey=1&course_edit=1`)
        } else {
          message.error(response.message)
        }
      }else{
        message.error(response.message)
      }
    }


  // 点击了建课按钮
  const onCourseForkClick = () => {
    if (!checkUserLogin()) {
      sessionStorage.setItem("previousurl",window.location.href )
      document.getElementById('show-login-modal')!.click()
    } else {
      sendHttpPostRequest(
        'course/api/user_create_course',
        {
          course_id: courseId,

          copy_menu: 1,
          copy_lecture: 1,
          copy_case: 1,

          college_id: collegeId,

          sessionid: Cookies.get('sessionid'),
        },
        setCreateCourseCallback
      )
    }
  }



  return (
    <Layout  className={courseMainStyles.mainDiv}>
      <LoginRegisterModal></LoginRegisterModal>

      <div className={courseMainStyles.courseHeaderWrapper}>
        
        <Row
          className={courseMainStyles.courseInfoDiv}
          align="middle"
          wrap={false}
        >
          <Col
            flex="auto"
          >
            <div className={courseMainStyles.courseName}>{courseName} 
            <span
              className={courseMainStyles.platformTag}
            >
              {'平台'}
            </span> 
            </div>


            <div style={{margin:'0 0 8px', fontSize:18, fontWeight:600}}>课程简介</div>
            <div title= {courseDescription} className={courseMainStyles.courseIntroduction}>
              {courseDescription}
            </div>


          { isPay == true &&   <div className={courseMainStyles.datecourse}> 
              <Row align="middle" gutter={[8, 0]}>
                <Col>
                  <div>
                   <CalendarOutlined  style={{color:'#07c160', marginRight:5}}/>  有效期：{course?.apply_start_time?.slice(0, 10)} 至 {course?.apply_end_time?.slice(0, 10)}
                  </div>
                </Col>
              </Row>
            </div> }

          </Col>

          <Col flex="300px" style={{ marginLeft: 16, textAlign: "right" }}>
            <div >
              <img
                src={
                  courseCover && courseCover?.startsWith('http')
                    ? courseCover
                    : constants.BACKEND_URL + courseCover
                }

               className={courseMainStyles.courseImage}
              />
            </div>
          </Col>

        </Row>

        <div className={courseMainStyles.headerActionDiv} >
            {isPay == true &&  isCollegeTeacher==false && course?.isoutdate == 0 && (
              <span
                className={courseMainStyles.BtnDark}
                onClick={onCourseLearnClick}
              >
                开始学习
              </span>
            )}
            {isPay == true &&  isCollegeTeacher==true && course?.isoutdate == 0 && (<>
                <span
                  onClick={onCourseLearnClick}
                  className={courseMainStyles.BtnLight}
                >
                  
                  <Icon component={eyeIcon}/>  预览
                </span>

                <span
                className={courseMainStyles.BtnDark}
                style={{marginLeft: 12}}
                onClick={onCourseForkClick}
               >
                模板建课
              </span>
            </>
            )}
          {isPay == true && course?.isoutdate != 0 && (
              <span
                className={courseMainStyles.BtnDisable}
              >
                已过期
              </span>
            )}

          {isPay == false  && (
              <span
                className={courseMainStyles.BtnDisable}
              >
                未购买
              </span>
            )}
          </div>

      </div>

      <div className={courseMainStyles.courseTabsWrapper}>
        <Tabs
          defaultActiveKey={'1'}
          //type="card"
          size="middle"
          tabPosition="top"
        >
          {isLogin == true ? (
            <TabPane tab={<div><Icon component={mymenuIcon}/>  大纲</div>} key="1">
              {course?.syllabus_id > 0 && (
                <PlatformMenuPreview
                  menu_id={course?.syllabus_id}
                  course_id={course?.id}
                  ispay={isPay}
                  is_teacher={isCollegeTeacher}
                  is_in_college={collegeId > 0}
                  is_outdate={course?.isoutdate == 1}
                />
              )}
            </TabPane>
          ) : (
            <TabPane tab={<div><Icon component={mymenuIcon}/>  大纲</div>} key="1">
              {course?.syllabus_id > 0 && (
                <LockedMenuPreview menu_id={course?.syllabus_id} />
              )}
            </TabPane>
          )}
          { isCollegeTeacher == 1 &&  <TabPane tab={<div><Icon component={myslidesIcon}/>  课件</div>} key="2">
            <PlatformCourseSlides 
            course_id={course?.id}
            is_pay={isPay}
            is_overdue={isOverDue}
            />
          </TabPane> }

          { isCollegeTeacher == 1 &&  <TabPane tab={<div> <ExperimentOutlined /> 实验</div>} key="3">
            <PlatformCourseCases 
            course_id={course?.id}
            is_pay={isPay}
            is_overdue={isOverDue}
            />
          </TabPane> }

          { isCollegeTeacher == 1 &&  <TabPane tab={<div> <Icon component={myexerciseIcon}/>  习题</div>} key="11">
            <PlatformCourseExercises 
            course_id={course?.id}
            is_pay={isPay}
            is_overdue={isOverDue}
            />
          </TabPane> }

        </Tabs>
      </div>


      <Feedback />
    </Layout>
  )
}

export default CourseMain
